import { useState } from "react";

import blackDeleteIcon from "../../assets/black-delete-icon.svg";
import whiteRightIcon from "../../assets/white-right-icon.svg";
import uplaodIcon from "../../assets/upload-green-icon.svg";
import saveIcon from "../../assets/save-icon.svg";
import infoIcon from "../../assets/info-icon.svg";

const ImplantsForm = ({ data }) => {
  console.log("Implants Data", data);
  const [implantName, setImplantName] = useState("");
  const [quantity, setQuantity] = useState("");

  const implantsData = data || [];

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      {/* Top Fields */}
      <div className="flex items-center justify-between pt-[30px]">
        <div className="flex items-center gap-[4px]">
          {/* Implant Select */}
          <div className="w-[280px] h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[14px] flex items-center">
            <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] whitespace-nowrap">
              {implantName || "Select"}
            </span>

            <div className="ml-auto flex items-center">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                  d="M7 10.5L14 17.5L21 10.5"
                  stroke="#5AC69F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          {/* Quantity */}
          <div className="w-[280px] h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[14px] flex items-center">
            <span className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] whitespace-nowrap">
              {quantity || "Quantity"}
            </span>

            <div className="ml-auto flex items-center">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                  d="M7 10.5L14 17.5L21 10.5"
                  stroke="#5AC69F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Add Button */}
        <button className="w-[155px] h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]">
          ADD
        </button>
      </div>
      {/* Table Section */}
      <div className="pt-[42px]">
        {/* Table Header */}
        <div className="xl:grid xl:grid-cols-[28px_320px_226px_58px_85px_42px] xl:gap-x-[51px] 2xl:grid 2xl:grid-cols-[28px_320px_220px_60px_87px_42px] 2xl:gap-x-[76px] 3xl:grid 3xl:grid-cols-[40px_420px_345px_190px_251px_40px] gap-x-[18px]  3xl:gap-x-[35px] items-start">
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Name
          </div>

          <div className="font-lufga font-normal text-[14px] pl-12 leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Upload
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Quantity
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Amount
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Action
          </div>
        </div>

        {/* Table Body */}
        <div className="mt-[34px] flex flex-col gap-y-[34px]">
          {implantsData.map((item, index) => (
            <div
              key={index}
              className="xl:grid xl:grid-cols-[28px_320px_226px_58px_80px_42px] xl:gap-x-[51px] 2xl:grid 2xl:grid-cols-[28px_320px_226px_58px_80px_42px] 2xl:gap-x-[76px] 3xl:grid 3xl:grid-cols-[40px_420px_360px_180px_240px_40px] gap-x-[18px] 3xl:gap-x-[35px] items-start"
            >
              {/* Number */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.
              </div>

              {/* Name */}
              <div className="truncate font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.name}
              </div>

              {/* Upload */}
              <div className="flex items-center gap-[6px]">
                {/* Upload Icon */}

                <img src={uplaodIcon} alt="upload" w-12 h-12 />

                {/* Upload Text */}
                <div className="flex items-center gap-[4px]">
                  <span className="underline font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                    Drag your file here or Browse
                  </span>

                  {/* Info Icon */}

                  <img src={infoIcon} alt="upload" w-14 h-14 />
                </div>
              </div>

              {/* Quantity */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.quantity}
              </div>

              {/* Amount */}
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.amount}
              </div>

              {/* Delete */}
              <div className="flex gap-[16px]">
                <button className="w-[55px] h-[28px] flex items-center justify-center rounded-[74.8px] border-[0.37px] border-solid bg-white border-[#FF4343] px-[8px] py-[6px]">
                  <span className="font-lufga font-normal text-[12px] leading-[100%] tracking-[-0.05em] text-center align-middle text-[#FF4343]">
                    Denied
                  </span>
                </button>
                <button className="flex items-center justify-self-end bg-transparent border-none">
                  <img src={blackDeleteIcon} alt="delete icon" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Save Button */}
      <div className="flex justify-end mt-[12px]">
        <button className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px]  2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal">
          SAVE
          <img src={saveIcon} alt="save" className="pl-[16px]" />
        </button>
      </div>
    </div>
  );
};

export default ImplantsForm;
